import React, { useEffect, useState } from "react";
import {
  Page,
  Text,
  View,
  Document,
  Image as ReactPdfImage,
} from "@react-pdf/renderer";

// Custom.
import { TemplateProps } from "../global";
import { styles } from "./styles";
import { baseStyles } from "../styles";
// import Image from "@vocollege/components/dist/Image";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { getContactName } from "@vocollege/app/dist/modules/VoHelpers";
import LogoPlaceholder from "../components/LogoPlaceholder/LogoPlaceholder";
import { GeneralObject } from "@vocollege/app/dist/global";
import {
  getGroupLogotype,
  convertSvgToImage,
} from "@vocollege/app/dist/modules/VoHelpers";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import LogoSvg from "@vocollege/theme/dist/images/vocollege-2.svg";

const DiplomaTemplate: React.FC<TemplateProps> = (props) => {
  const { item } = props;
  const [logotype, setLogotype] = useState<any>(null);

  // Methods.
  const setImage = async () => {
    let output: GeneralObject[] = [];
    try {
      let logoToConvert = VoAuth.ability.can("create_all_diplomas", "Cert")
        ? LogoSvg
        : null;

      if (item.educator) {
        getGroupLogotype(item.educator, "logo2", output);
        if (output.length > 0) {
          logoToConvert = output[0].url;
        }
      }

      if (logoToConvert) {
        let convertedLogo = await convertSvgToImage(logoToConvert, 260);
        setLogotype(convertedLogo);
      }

      // getGroupLogotype(item.educator, "logo2", output);
      // if (output.length > 0) {
      //   let convertedImage = await convertSvgToImage(output[0].url, 260);
      //   setLogotype(convertedImage);
      // }
    } catch (error) {
      console.error(error);
    }
  };

  // Effects.

  useEffect(() => {
    if (item) {
      setImage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  return (
    // @ts-ignore
    <Document>
      {/*
 // @ts-ignore */}
      <Page size="A4" style={[baseStyles.page, styles.page]} wrap={false}>
        <View style={styles.decor}>
          <View style={[baseStyles.section, styles.logoWrapper]}>
            {logotype && (
              <ReactPdfImage src={logotype} style={baseStyles.logo} />
            )}
            {!logotype && <LogoPlaceholder />}
          </View>

          <View style={baseStyles.section}>
            <Text style={styles.title}>{I18n.get.diploma.template.title}</Text>
          </View>

          <View style={baseStyles.section}>
            <Text style={styles.person}>
              {item &&
                (item.firstname || item.lastname) &&
                getContactName(item)}
            </Text>
            <Text style={styles.personalNumber}>
              {item && item.personal_number}
            </Text>
          </View>
          <View style={baseStyles.section}>
            <Text style={styles.text}>{I18n.get.diploma.template.text}</Text>
            {item && item.educator && (
              <Text style={styles.text}>{item.educator.title}</Text>
            )}
            {item && (
              <Text style={styles.text}>
                {["yh"].includes(item.diploma_type) && item.education_freetext}
                {["ung", "vuxen"].includes(item.diploma_type) &&
                  I18n.get.diploma.education[item.diploma_type][item.education]}
              </Text>
            )}
            {item && (
              <Text style={styles.text}>
                {I18n.trans(
                  I18n.get.diploma.template.credits[item.diploma_type],
                  { credits: item.credits }
                )}
              </Text>
            )}
          </View>
          <View style={baseStyles.section}>
            {item && item.educator && item.educator.parentGroups[0] && (
              <Text style={styles.text}>
                {I18n.trans(I18n.get.diploma.template.place, {
                  college: item.educator.parentGroups[0].title,
                })}
              </Text>
            )}
            {item && item.date && <Text style={styles.text}>{item.date}</Text>}
          </View>

          <View style={baseStyles.grow}></View>

          <View style={[baseStyles.section, styles.footer]}>
            {item &&
              ((item.president && item.president !== "") ||
                (item.principal && item.principal !== "")) && (
                <View style={styles.signatures}>
                  {item && item.president && item.president !== "" && (
                    <View style={styles.signature}>
                      <Text style={styles.signaturePerson}>
                        {item.president}
                      </Text>
                      <Text style={styles.signatureTitle}>
                        {I18n.get.diploma.template.president}
                      </Text>
                    </View>
                  )}
                  {item && item.principal && item.principal !== "" && (
                    <View style={styles.signature}>
                      <Text style={styles.signaturePerson}>
                        {item.principal}
                        {/* {getContactName(item.principal)} */}
                      </Text>
                      <Text style={styles.signatureTitle}>
                        {VoAuth.ability.can("create_all_diplomas", "Cert") &&
                        !item.educator
                          ? I18n.get.vocertMisc.voCollegeKansli
                          : I18n.get.diploma.template.principal}
                      </Text>
                    </View>
                  )}
                </View>
              )}
            {item && item.educator && (
              <Text style={styles.educatorCertified}>
                {I18n.trans(I18n.get.diploma.template.certifiedSince, {
                  educator: item.educator.title,
                  date: item.educator.certified,
                })}
              </Text>
            )}
          </View>
          {item && item.uid && item.uid.code && (
            <Text style={[baseStyles.uid, styles.uid]}>{item.uid.code}</Text>
          )}
        </View>
      </Page>
    </Document>
  );
};
export default DiplomaTemplate;
